import React from "react";
import { chakra } from "@chakra-ui/react";
import { FaReceipt, FaCircleNotch } from "react-icons/fa";

import styles from "./Styles.module.css";
import Header from "components/Header";
import Footer from "components/Footer";

export default function Guideline() {
  let language = localStorage.getItem("language");
  const newLanguage = require(`language/${language!}.json`);

  return (
    <>
      <Header />
      <chakra.div className={styles.container}>
        <chakra.h1>{newLanguage.guideline.title}</chakra.h1>

        <chakra.div className={styles.content}>
          <chakra.div className={styles.topics}>
            <chakra.h3>{newLanguage.guideline.description}</chakra.h3>

            <chakra.a href="#" color="#0A4E6D">
              <chakra.span color="#fff">Discord</chakra.span>
              https://discordapp.com/guidelines
            </chakra.a>
          </chakra.div>
        </chakra.div>
        <chakra.div className={styles.content}>
          <chakra.div className={styles.topics}>
            <chakra.h3>
              <FaReceipt /> &nbsp; {newLanguage.guideline.first.title}
            </chakra.h3>
            <chakra.ul>
              {newLanguage.guideline.first.rules.map((element: any) => (
                <chakra.li>{element}</chakra.li>
              ))}
            </chakra.ul>
          </chakra.div>
        </chakra.div>

        <chakra.div className={styles.content}>
          <chakra.div className={styles.topics}>
            <chakra.h3>
              <FaReceipt /> &nbsp; {newLanguage.guideline.second.title}
            </chakra.h3>

            <chakra.h4>
              <FaCircleNotch />
              &nbsp;{newLanguage.guideline.second.oneTopic.title}
            </chakra.h4>

            <chakra.ul>
              {newLanguage.guideline.second.oneTopic.rules.map(
                (element: any) => (
                  <chakra.li>{element}</chakra.li>
                )
              )}
            </chakra.ul>

            <chakra.h4>
              <FaCircleNotch />
              &nbsp;{newLanguage.guideline.second.twoTopic.title}
            </chakra.h4>

            <chakra.ul>
              {newLanguage.guideline.second.twoTopic.rules.map(
                (element: any) => (
                  <chakra.li>{element}</chakra.li>
                )
              )}
            </chakra.ul>

            <chakra.h4>
              <FaCircleNotch />
              &nbsp;{newLanguage.guideline.second.threeTopic.title}
            </chakra.h4>

            <chakra.ul>
              {newLanguage.guideline.second.threeTopic.rules.map(
                (element: any) => (
                  <chakra.li>{element}</chakra.li>
                )
              )}
            </chakra.ul>

            <chakra.h4>
              <FaCircleNotch />
              &nbsp;{newLanguage.guideline.second.fourTopic.title}
            </chakra.h4>

            <chakra.ul>
              {newLanguage.guideline.second.fourTopic.rules.map(
                (element: any) => (
                  <chakra.li>{element}</chakra.li>
                )
              )}
            </chakra.ul>
          </chakra.div>
        </chakra.div>
      </chakra.div>
      <Footer />
    </>
  );
}
